import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const PenToolSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2929 11.2929C18.6834 10.9024 19.3166 10.9024 19.7071 11.2929L22.7071 14.2929C23.0976 14.6834 23.0976 15.3166 22.7071 15.7071L15.7071 22.7071C15.3166 23.0976 14.6834 23.0976 14.2929 22.7071L11.2929 19.7071C10.9024 19.3166 10.9024 18.6834 11.2929 18.2929L18.2929 11.2929ZM13.4142 19L15 20.5858L20.5858 15L19 13.4142L13.4142 19Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.29291 1.29291C1.53925 1.04658 1.89602 0.946197 2.23466 1.02794L16.7347 4.52794C17.1132 4.6193 17.4042 4.92208 17.4806 5.3039L18.9806 12.8039C19.0462 13.1318 18.9436 13.4707 18.7071 13.7071L13.7071 18.7071C13.4707 18.9436 13.1318 19.0462 12.8039 18.9806L5.3039 17.4806C4.92208 17.4042 4.6193 17.1132 4.52794 16.7347L1.02794 2.23466C0.946197 1.89602 1.04658 1.53925 1.29291 1.29291ZM3.35606 3.35606L6.32228 15.6447L12.6713 16.9145L16.9145 12.6713L15.6447 6.32228L3.35606 3.35606Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.87876 10.293L1.29297 2.70718L2.70718 1.29297L10.293 8.87876L8.87876 10.293Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 10C10.4477 10 10 10.4477 10 11C10 11.5523 10.4477 12 11 12C11.5523 12 12 11.5523 12 11C12 10.4477 11.5523 10 11 10ZM8 11C8 9.34315 9.34315 8 11 8C12.6569 8 14 9.34315 14 11C14 12.6569 12.6569 14 11 14C9.34315 14 8 12.6569 8 11Z"
        fill={color}
      />
    </svg>
  );
};

export { PenToolSvg };
